import {
  GET_DELIVERY_TYPE_LIST,
  GET_DELIVERY_TYPE_LIST_SUCCESS,
  GET_DELIVERY_TYPE_LIST_FAIL,
  GET_SINGLE_DELIVERY_TYPE,
  GET_SINGLE_DELIVERY_TYPE_SUCCESS,
  GET_SINGLE_DELIVERY_TYPE_FAIL,
  DELETE_DELIVERY_TYPE_REQUEST,
  DELETE_DELIVERY_TYPE_SUCCESS,
  DELETE_DELIVERY_TYPE_FAIL,
  ADD_DELIVERY_TYPE_REQUEST,
  ADD_DELIVERY_TYPE_SUCCESS,
  ADD_DELIVERY_TYPE_FAIL,
  UPDATE_DELIVERY_TYPE_REQUEST,
  UPDATE_DELIVERY_TYPE_SUCCESS,
  UPDATE_DELIVERY_TYPE_FAIL,
} from "src/constants/types";

export const deliveryTypeReducers = (state = {}, actions) => {
  switch (actions.type) {
    case GET_DELIVERY_TYPE_LIST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_DELIVERY_TYPE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        deliveryTypeList: actions.payload,
        error: "",
      };
    case GET_DELIVERY_TYPE_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case GET_SINGLE_DELIVERY_TYPE:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_SINGLE_DELIVERY_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        deliveryType: actions.payload,
      };
    case GET_SINGLE_DELIVERY_TYPE_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case DELETE_DELIVERY_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case DELETE_DELIVERY_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case DELETE_DELIVERY_TYPE_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case ADD_DELIVERY_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case ADD_DELIVERY_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case ADD_DELIVERY_TYPE_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case UPDATE_DELIVERY_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case UPDATE_DELIVERY_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_DELIVERY_TYPE_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    default:
      return state;
  }
};
